var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67 2H16.34C19.73 2 22 4.38 22 7.92V16.091C22 19.621 19.73 22 16.34 22H7.67C4.28 22 2 19.621 2 16.091V7.92C2 4.38 4.28 2 7.67 2ZM15.01 15C15.35 14.661 15.35 14.111 15.01 13.771L13.23 11.991L15.01 10.21C15.35 9.871 15.35 9.311 15.01 8.971C14.67 8.63 14.12 8.63 13.77 8.971L12 10.75L10.22 8.971C9.87 8.63 9.32 8.63 8.98 8.971C8.64 9.311 8.64 9.871 8.98 10.21L10.76 11.991L8.98 13.761C8.64 14.111 8.64 14.661 8.98 15C9.15 15.17 9.38 15.261 9.6 15.261C9.83 15.261 10.05 15.17 10.22 15L12 13.231L13.78 15C13.95 15.181 14.17 15.261 14.39 15.261C14.62 15.261 14.84 15.17 15.01 15Z",
    fill: "#FF5630"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedx);
export default __webpack_public_path__ + "static/media/redx.3b216f2a.svg";
export { ForwardRef as ReactComponent };